
// src/connects/group-timeline-page.js

import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'
import { inject } from '../helpers/context'
import { trackPage } from '../helpers/analytics'
import { getArray } from '../helpers/store'
import socketRsync, { requireSocketEmit } from '../helpers/socket-rsync'
import config from '../config'
import find from 'lodash/find'
import { isSmartPhone } from '../helpers/agent-type'

export const mapStateToProps = (state, ownProps)=> {
  const diaries = state.diaries.groups[ownProps.params.group_id]

  return {
    group: getArray('group_id', state.groups.items, ownProps.params.group_id),
    user: state.user.current,
    isFetching: diaries && diaries.isFetching,
    isFetchFailed: diaries && diaries.isFetchFailed,
    hasMore: diaries && diaries.hasMore,
    diaries: diaries && diaries.items,
    isRightSidebar: (state.rightSidePage.name || ownProps.children) && true,
    isPhone: state.media.isPhone,
    firstLogin: state.user.firstLogin,
    productTour: state.productTour.state,
    access_token: state.sessions.access_token,
    likeConfig: state.likes.likeConfig,
    binding: true,
    blockDiaries: state.block.diaries,
    blockUsers: state.block.users
  }
}

export const mergeProps = (stateProps, dispatchProps, ownProps)=> {
  const redirect_url = `/v3/users/new?group_id=${ownProps.params.group_id}`
  return Object.assign({}, stateProps, dispatchProps, ownProps, {
    usersAdminUrl: `${config.baseUrl}v3/session/redirect?login=true&access_token=${stateProps.access_token}&redirect_to=`+encodeURIComponent(redirect_url),
    fetchDiaries: dispatchProps.fetchDiaries.bind(stateProps)
  })
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  function _readDiary(props, diary) {
    const read = diary.user.user_id == props.user.user_id || diary.readers && find(diary.readers, (reader)=> reader.user.user_id == props.user.user_id)
    if (!read) {
      !props.emitSocket('mark_as_read', { diary_id: diary.diary_id }) && dispatch(actions.markDiaryRead(diary.diary_id))
    }
  }

  return {
    fetchDiaries: function(props, reset = false) {
      if (this && this.binding) props = this
      if (props.isFetching || props.isFetchFailed && !reset) return
      var offset = reset ? 0 : props.diaries && props.diaries.length || 0
      offset == 0 && dispatch(actions.fetchGroupUnreadCount(ownProps.params.group_id))
      dispatch(actions.fetchDiaries(ownProps.params.group_id, offset))
    },

    fetchGroup: ()=> dispatch(actions.fetchGroup(ownProps.params.group_id)),

    clearDiaries: ()=> dispatch(actions.clearDiaries(ownProps.params.group_id)),

    readDiary: _readDiary,
    _readDiary: _readDiary,

    showUser:  (user)=> dispatch(actions.openRightSidePage('user_timeline', { group_id: ownProps.params.group_id, user_id: user.user_id, user: user })),
    closeRightSidePage: ()=> dispatch(actions.closeRightSidePage(true)),

    willMount: (props)=> {
      dispatch(actions.fetchDiaries(props.params.group_id, 0))
    },

    willUpdate: (props, nextProps)=> {
      if (props.params.group_id != nextProps.params.group_id) {
        dispatch(actions.closeRightSidePage(true))
        dispatch(actions.fetchDiaries(nextProps.params.group_id, 0))
      }
    },

    willUnmount: ()=> {
      if (!isSmartPhone) dispatch(actions.closeRightSidePage(true))
    },

    openGroupMembersPanel: ()=> dispatch(actions.openGroupSettingsPage('members')),

    receiveSocket: (message, message_type, props)=> {
      if (message.group_id == ownProps.params.group_id) {
        switch (message_type) {
        case 'diary':
          dispatch(actions.loadDiary(message.diary, {
            appending: message.appending,
            own_post: message.diary.user.user_id == props.user.user_id,
            group_id: message.group_id,
          }))
          break
        case 'diary_delete':
          dispatch(actions.loadDiary(message.diary, {
            deleted: true,
            group_id: message.group_id
          }))
          break
        }
      }
    },

    requestSync: ()=> dispatch(actions.fetchDiaries(ownProps.params.group_id, 0)),
  }
}

export default combineHOC(
  requireSocketEmit,
  connect(mapStateToProps, mapDispatchToProps, mergeProps),
  inject({ _readDiary: PropTypes.func }),
  socketRsync('diary', 'diary_delete'),
  lifecycle,
  translate(),
  trackPage('group_timeline'),
)



// WEBPACK FOOTER //
// ./src/connects/group-timeline-page.js